import Dropdown from 'components/Dropdown';
import { Loader } from 'components/Loader';
import { AuthContext } from 'context/AuthContext';
import { PropsWithChildren, useContext } from 'react';
import { CgProfile } from "react-icons/cg";

import { Link } from 'react-router-dom';
import { assetUrl } from 'utils/url';
import Layout from './Layout';

type Props = {
  title: string
}

export default function RequireAdmin({ title, children }: PropsWithChildren<Props>) {
  const { setDrawerShow, user } = useContext(AuthContext)

  if (user?.role === 'customerSupportManager') {
    window.location.replace('/customer-support/request')
    return <Loader className='h-screen' />
  }

  return (
    <Layout>
      <header className='bg-white flex items-center px-5 lg:px-9 py-5'>
        <svg
          className='lg:hidden cursor-pointer mr-3'
          onClick={() => setDrawerShow(true)}
          stroke='currentColor'
          fill='currentColor'
          strokeWidth='0'
          viewBox='0 0 1024 1024'
          height='25'
          width='25'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'></path>
        </svg>
        <h2 className='text-xl md:text-2xl font-medium'>{title}</h2>

        <div className="ml-auto flex items-center gap-4">
          <Dropdown
            selector={
              <button className="flex items-center gap-2 focus:outline-none">
                <p className="text-md max-w-[150px] truncate font-medium">
                  {user?.name}
                </p>

                <div className="w-11 h-11 flex justify-center items-center overflow-hidden rounded-full border border-slate-600">
                  {user?.photo ? (
                    <img
                      src={assetUrl + user?.photo}
                      alt="user"
                      className="h-full w-full object-cover rounded-full"
                    />
                  ) : (

                    <CgProfile className="h-7 w-7 text-slate-500" />
                  )}
                </div>

                <svg
                  className="w-4 h-4 text-slate-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            }
            className="w-52 p-0 mt-2"
            position="right"
          >
            <ul className="bg-white shadow-md rounded-md overflow-hidden">
              <li className="p-2 ">
                <Link className="block" to="/profile">
                  Profile
                </Link>
              </li>
            </ul>
          </Dropdown>
        </div>

      </header>
      <main className='p-4 md:p-6'>{children}</main>
    </Layout>
  )
}
